import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from 'react-redux'
import Providerx from '../src/provider/index'
import store from './redux/index'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Providerx>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Providerx>
    </Provider>
  </React.StrictMode >,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
